import React from 'react';
import CloudExecutiveDashboard from './CloudExecutiveDashboard';

const FinOpsDashboard: React.FC = () => {
  return <CloudExecutiveDashboard provider="azure" />;
};

export default FinOpsDashboard;
